import React from 'react';
import propTypes from 'prop-types';

import style from './index.less';

function TableHeader({ title = '', children, styles = {} }) {

  return (
    <div className={style.content} style={{ ...styles }}>
      <div className={style.content_title}>{title}</div>
      <div className={style.children}>{children}</div>
    </div>
  );
}

TableHeader.propTypes = {
  /** 左边显示的内容 */
  title: propTypes.oneOfType([propTypes.string, propTypes.element]),
  children: propTypes.oneOfType([propTypes.any]),
  styles: propTypes.object
};

export default TableHeader;
